import { useState } from "react";
import { useNavigate } from "react-router";
import { ListRequest } from "@/services/backend/processes/api/process-api";
import { CreateProcessDialog } from "@/services/backend/processes/components/create-process-dialog";
import {
  ProcessTable,
  ProcessTableFilters,
  useDefaultProcessListRequest,
} from "@/services/backend/processes/components/process-table";
import { ProcessLinkButton } from "@/routes/_components/links/process-link-button";
import { CreateProcessDropdown } from "@/services/backend/processes/components/create-process-dropdown";
import { useActiveCompany } from "@/shared/lib/active-company/active-company-provider";
import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";

export function Processes() {
  const defaultRequest = useDefaultProcessListRequest();
  const [request, setRequest] = useState<ListRequest>(defaultRequest);
  const navigate = useNavigate();
  const { companyId } = useActiveCompany();
  const oneClick = useFeatureAuth("gsm.processes.process.create-one-click");

  return (
    <div className="grid gap-2">
      <div className="flex items-center justify-between gap-2">
        <ProcessTableFilters
          request={request}
          onRequestChange={setRequest}
          defaultRequest={defaultRequest}
        />
        {oneClick && (
          <CreateProcessDropdown
            companyId={companyId}
            onCreated={(processId, serviceKind) =>
              navigate(`/processes/${serviceKind.toLowerCase()}/${processId}`)
            }
          />
        )}
        {!oneClick && (
          <CreateProcessDialog
            onCreated={(processId, serviceKind) =>
              navigate(`/processes/${serviceKind.toLowerCase()}/${processId}`)
            }
          />
        )}
      </div>
      <ProcessTable
        request={request}
        onRequestChange={setRequest}
        renderRowLink={(processId, serviceKind, children) => (
          <ProcessLinkButton
            processId={processId}
            serviceKind={serviceKind}
            variant="link"
            size="sm"
          >
            {children}
          </ProcessLinkButton>
        )}
      />
    </div>
  );
}
